import { render, staticRenderFns } from "./MassiveChangesPopUp.vue?vue&type=template&id=9db26420&scoped=true&"
import script from "./MassiveChangesPopUp.vue?vue&type=script&lang=js&"
export * from "./MassiveChangesPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MassiveChangesPopUp.vue?vue&type=style&index=0&id=9db26420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db26420",
  null
  
)

export default component.exports